import React, {useCallback, useState} from "react";
import i18n from "../../../../locale/i18n";
import RestClientInstance from "../../../../lib/RestClient";
import {Button, Icon} from "semantic-ui-react";

interface MailBoxAuthRequestResetProps {
  isInitialized: boolean;

  onResetRequested(): void;
  onClickCodeAlreadyReceived(): void;
  onClickBackToLogin(): void;
}

const t = i18n.t.bind(i18n);

function cleanLanguageTag(language: string | undefined) {
  if(!language) {
    return '';
  }
  if(language.length > 2) {
    return language.substring(0, 2).toUpperCase();
  }
  return language.toUpperCase();
}


function MailBoxAuthRequestReset(props: MailBoxAuthRequestResetProps) {
  const { isInitialized, onResetRequested, onClickCodeAlreadyReceived, onClickBackToLogin } = props;

  const [requestingReset, setRequestingReset] = useState<boolean>(false);
  const [requestResetError, setRequestResetError] = useState<string>('');
  const requestReset = useCallback(() => {
    if(requestingReset) {
      return;
    }
    setRequestResetError('');
    setRequestingReset(true);
    const lng = cleanLanguageTag(i18n.language);
    RestClientInstance.post('mailbox/auth/request-reset?lng=' + encodeURIComponent(lng))
      .then(response => {
        if(response.data.success) {
          onResetRequested();
        } else {
          setRequestingReset(false);
          let errorMessage = 'Error: ' + response.data.message;
          switch(response.data.message) {
            case 'reset_already_sent':
              errorMessage = t('MailBox.Auth.Error.ResetAlreadySent');
              break;
            default:
          }
          setRequestResetError(errorMessage);
        }
      }).catch(error => {
      setRequestingReset(false);
    });
  }, [requestingReset, onResetRequested]);

  return <>
    {isInitialized && <p>{t('MailBox.Auth.Reset.ResetParagraph1')}</p>}
    {isInitialized && <p>{t('MailBox.Auth.Reset.ResetParagraph2')}</p>}

    {!isInitialized && <p>{t('MailBox.Auth.Reset.UninitializedParagraph1')}</p>}
    {!isInitialized && <p>{t('MailBox.Auth.Reset.UninitializedParagraph2')}</p>}


    <p className="" style={{color: '#89220a'}}>
      {requestResetError || <>&nbsp;</>}
    </p>

    <Button type="button" primary onClick={requestReset} loading={requestingReset}>
      <Icon name="mail"/> {t('MailBox.Auth.Reset.ButtonRequestCode')}
    </Button>

    <Button type="button" disabled={requestingReset} onClick={onClickCodeAlreadyReceived}>
      {t('MailBox.Auth.Reset.ButtonCodeAlreadyRequested')}
    </Button>

    {isInitialized && <>
      <br /><br />
      <Button type="button" basic className="link" disabled={requestingReset} onClick={onClickBackToLogin}>
        {t('MailBox.Auth.Reset.ButtonBackToLogin')}
      </Button>
    </>}
  </>;
}

export default MailBoxAuthRequestReset;